module.exports = __webpack_public_path__ + "static/media/github-light.afbdb6d2.svg";